import miscProvider from '../../helpers/assets/miscProvider'
import { IAssetData } from '../../helpers/data/assetData'

const rotate_point = (cx: number, cy: number, angle: number, x: number, y: number) => {
	const p = {
		x,
		y,
	}
	const s = Math.sin(angle)
	const c = Math.cos(angle)

	// translate point back to origin:
	p.x -= cx
	p.y -= cy

	// rotate point
	const xnew = p.x * c - p.y * s
	const ynew = p.x * s + p.y * c

	// translate point back:
	p.x = xnew + cx
	p.y = ynew + cy
	return p
}

const buildSlide = (assets: IAssetData[]) => {
	const total = 50
	let i = 0
	const slideElements = []
	while (i < total) {
		let pt
		if (i / total < 40 / 260) {
			pt = rotate_point(0, 700, (36 * Math.PI) / 180, 10 * Math.random(), -167 + 867 * Math.random())
			// pt = this.rotate_point(0, 700, 35.6 * Math.PI / 180, 512 * Math.random(), -167 + 867 * Math.random())
			// pt = this.rotate_point(0, 700, 35.6 * Math.PI / 180, 0, -167 + 867 * Math.random())
			// pt.y -= 170
			pt.x -= 110
		} else {
			pt = rotate_point(0, 700, (36 * Math.PI) / 180, 250 * Math.random(), -167 + 867 * Math.random())
			pt.x += 190
		}
		const assetData: IAssetData = miscProvider(assets)
		slideElements.push({
			asset: {
				type: assetData.type,
				path: assetData.path,
			},
			x: pt.x,
			y: pt.y,
			w: (assetData.width || 1) * 1,
			h: (assetData.height || 1) * 1,
		})
		i += 1
	}
	return slideElements
}

export default buildSlide
